import NotificationsRepository from 'client-sdk/src/Repository/notifications-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_PARTNER_CONFIGS,
  GET_PARTNER_CONFIGS_SUCCESS,
  GET_PARTNER_CONFIGS_FAILED,
  UPDATE_PARTNER_CONFIGS,
  UPDATE_PARTNER_CONFIGS_SUCCESS,
  UPDATE_PARTNER_CONFIGS_FAILED,
} from './constants';

import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';

export function* getPartnerConfig(actions: any): unknown {
  try {
    const {response} =yield NotificationsRepository.getPartnerConfig(actions);
    yield put({
      type: GET_PARTNER_CONFIGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNER_CONFIGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updatePartnerConfig(actions: any): unknown {
  try {
    const {id} = actions.payload;
    yield NotificationsRepository.updatePartnerConfig(actions);
    yield put({
      type: UPDATE_PARTNER_CONFIGS_SUCCESS,
    });
    yield put({
      type: GET_PARTNER_CONFIGS,
      payload: {id, sort: 'id, desc'},
    });
    handleNotfication('وضعیت تامین کننده با موفقیت تغییر پیدا کرد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_PARTNER_CONFIGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* notificationSaga() {
  yield takeLatest(GET_PARTNER_CONFIGS, getPartnerConfig);
  yield takeLatest(UPDATE_PARTNER_CONFIGS, updatePartnerConfig);
}
